import { Action } from 'redux';
import { BffCmsHeroBackgroundResponse } from '@lucky7ventures/bff-types';

export enum HeroBackgroundsActionType {
  GetHeroBackgrounds = 'GET_HERO_BACKGROUNDS',
  GetHeroBackgroundsSuccess = 'GET_HERO_BACKGROUNDS_SUCCESS',
  GetHeroBackgroundsError = 'GET_HERO_BACKGROUNDS_ERROR',
}

export type GetHeroBackgroundsAction = Action<HeroBackgroundsActionType.GetHeroBackgrounds>;
export type GetHeroBackgroundsSuccessAction =
  Action<HeroBackgroundsActionType.GetHeroBackgroundsSuccess> & {
    heroBackgrounds: BffCmsHeroBackgroundResponse;
  };
export type GetHeroBackgroundsErrorAction =
  Action<HeroBackgroundsActionType.GetHeroBackgroundsError>;

export type HeroBackgroundsActions =
  | GetHeroBackgroundsAction
  | GetHeroBackgroundsSuccessAction
  | GetHeroBackgroundsErrorAction;

export const getHeroBackgrounds = (): GetHeroBackgroundsAction => ({
  type: HeroBackgroundsActionType.GetHeroBackgrounds,
});

export const getHeroBackgroundsSuccess = (
  heroBackgrounds: BffCmsHeroBackgroundResponse,
): GetHeroBackgroundsSuccessAction => ({
  type: HeroBackgroundsActionType.GetHeroBackgroundsSuccess,
  heroBackgrounds,
});

export const getHeroBackgroundsError = (): GetHeroBackgroundsErrorAction => ({
  type: HeroBackgroundsActionType.GetHeroBackgroundsError,
});
